
































































import { Vue, Component, Mixins } from "vue-property-decorator";
import StadiumMap from "./charts/stadium_map.vue";
import StadiumRank from "./charts/stadium_rank.vue";
import UserMap from "./charts/user_map.vue";
import UserRank from "./charts/user_rank.vue";
import BillMap from "./charts/bill_map.vue";
import BillRank from "./charts/bill_rank.vue";
import PaymentMap from "./charts/payment_map.vue";
import PaymentRank from "./charts/payment_rank.vue";

import AllStadium from "./charts/allstadium.vue";
import StadiumMap1 from "./charts/stadium_map1.vue";
import StadiumMap2 from "./charts/stadium_map2.vue";

@Component({
  components: {
    StadiumMap,
    StadiumRank,
    UserMap,
    UserRank,
    BillMap,
    BillRank,
    PaymentMap,
    PaymentRank,
    AllStadium,
    StadiumMap1,
    StadiumMap2
  }
})
export default class extends Mixins() {}
